export function updateContactNameOnConversation(data) {
  return {
    type: '@ANSWERED_CONVERSATION/UPDATE_CONTACT_NAME',
    payload: {
      data
    }
  };
}
